<div class="container-fluid">
  <app-header titleText="QUOTES" i18n-titleText progressBarState="quote">
    <div button>
      <a *ngIf="canAddQuote" routerLink="/quote/add" class="btn btn-bidit-navigate" i18n>Add Quote</a>
    </div>
  </app-header>

  <div class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/quotes_circle.png" alt="Quotes Icon" class="card-icon" />
      <h5 i18n>Quote List</h5>
      <form class="row" (ngSubmit)="refreshSummary()">
        <div class="col-sm-2">
          <input name="projectName" id="projectName"
                 class="form-control" placeholder="Search Projects" i18n-placeholder
                 [(ngModel)]="filter.projectName" #projectName="ngModel" />
        </div>
        <div class="col-sm-2">
          <select name="dateRange" id="dateRange"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.dateRange" #dateRange="ngModel">
            <option value="null" i18n>Select Created Date Range</option>
            <option value="1" i18n>Current Month</option>
            <option value="2" i18n>Current Quarter</option>
            <option value="3" i18n>Current Year</option>
            <option value="4" i18n>Prior Month</option>
            <option value="5" i18n>Prior Quarter</option>
            <option value="6" i18n>Prior Year</option>
          </select>
        </div>
        <div class="col-sm-2">
          <select name="jobTypeId" id="jobTypeId"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.jobTypeId" #salespersonId="ngModel">
            <option [ngValue]="null" i18n>Select Job Type</option>
            <option *ngFor="let jobType of summary?.jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
          </select>
        </div>
        <div class="col-sm-2">
          <select name="salespersonId" id="salespersonId"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.salespersonId" #salespersonId="ngModel">
            <option value="" i18n>Select Salesperson</option>
            <option *ngFor="let salesperson of summary?.salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
          </select>
        </div>
        <div class="col-sm-2">
          <select name="statusId" id="statusId"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.statusId" #statusId="ngModel">
            <option [ngValue]="undefined" i18n>Select Status</option>
            <option value="1" selected i18n>Active Quotes</option>
            <option value="2" i18n>Lost Quotes</option>
            <option value="3" i18n>Expired Quotes</option>
            <option [ngValue]="undefined" i18n>All Statuses</option>
          </select>
        </div>
        <div class="col-sm-2">
          <button type="submit" class="btn btn-bidit-action" onclick="this.blur();" i18n>Apply Filter</button>
        </div>
      </form>

      <h5 i18n>Click on quote name to update the quote</h5>
      <app-spinner [isRunning]="dataSource.loading$ | async"></app-spinner>

      <mat-table class="table-bidit table-striped" style="width: 100%;" [dataSource]="dataSource"
                 matSort matSortActive="projectName" matSortDirection="asc">
        <ng-container matColumnDef="projectName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Project Name</mat-header-cell>
          <mat-cell *matCellDef="let quote">
            <a routerLink="/quote/{{quote.quote_ID}}">
              {{quote.quote_Name}}
            </a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="projectNbr">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Project Nbr</mat-header-cell>
          <mat-cell *matCellDef="let quote">
            {{quote.quote_ProjectNumber}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Customer</mat-header-cell>
          <mat-cell *matCellDef="let quote">
            {{quote.customer?.customer_BusinessName}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="jobType">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Job Type</mat-header-cell>
          <mat-cell *matCellDef="let quote">
            {{quote.jobType?.jobType_Desc}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="bidAmount">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Bid Amount</mat-header-cell>
          <mat-cell *matCellDef="let quote">
            <ng-template [ngIf]="quote.totalBidAmount">
              ${{quote.totalBidAmount | number: '1.2-2'}}
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="quoteDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Quote Date</mat-header-cell>
          <mat-cell *matCellDef="let quote">
            {{quote.quote_QuoteDate | date:'MM/dd/yyyy'}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="projectStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Status</mat-header-cell>
          <mat-cell *matCellDef="let quote">
            <div *ngIf="quote.quote_IsLost" i18n>Lost</div>
            <div *ngIf="quote.isExpired" i18n>Expired</div>
            <div *ngIf="quote.quote_IsLost == false && quote.isExpired == false" i18n>Active</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="acknowledgementStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Acknowledged Status</mat-header-cell>
          <mat-cell *matCellDef="let quote" i18n>{{quote.acknowledgementStatus}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="salesperson">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Salesperson</mat-header-cell>
          <mat-cell *matCellDef="let quote">
            <div>
              <div *ngFor="let quoteAssignment of quote.quoteAssignments">
                {{quoteAssignment.assignedTo.firstName}} {{quoteAssignment.assignedTo.lastName}}
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header"></mat-header-cell>
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let quote">
            <a routerLink="/quote/{{quote.quote_ID}}" [queryParams]="{mode: 'edit'}" class="btn btn-bidit-edit mr-1"></a>
            <button *ngIf="canAddJob" type="button" (click)="convertQuote(quote)" onclick="this.blur();" class="btn btn-bidit-action" i18n>Convert to Job</button>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator [length]="summary?.quoteCount" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
    </div>
  </div>
</div>

